import * as React from "react";
const SvgFiBrandsC = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#151A2D"
      d="M16.592 9.197s-.354-3.298-3.626-3.39-4.954 2.473-4.954 6.138 1.858 6.597 5.042 6.597 3.538-3.665 3.538-3.665l6.103.366s.36 3.31-2.195 5.835-5.689 2.938-7.878 2.921-5.225.034-8.16-2.972-3.433-5.927-3.433-8.796.557-6.67 4.047-9.552C7.448.722 9.852 0 12.257 0c10.04 0 10.714 9.26 10.714 9.26z"
    />
  </svg>
);
export default SvgFiBrandsC;
